import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { AnnexModel } from '../models/AnnexModel';
import { URLsConfig } from '../URLsConfig';
@Injectable()
export class AnnexService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getAnnexLookup(patientCode: string, compCode: string) {
        let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("compCode", compCode);
        const options = {
            params: params
        };
        return this.http.get<AnnexModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Annex/AnnexLookup', options);
    }

    public addAnnex(annex: AnnexModel[]) {
        return this.http.post<AnnexModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Annex/AddAnnex', annex);
    }

    public deleteAnnex(patientCode: string, compCode: string) {
        let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("compCode", compCode);
        const options = {
            params: params
        };
        return this.http.get<AnnexModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/Annex/DeleteAnnex', options);
    }
}
